<icc-list
    [searchable]="true"
    [items]="fittings"
    [itemTemplate]="'itemImgTitleDescription'"
    itemImgHeight="medium"
    (select)="selectFitting($event)"
    itemImgHeight="high"
    [vertical]="true"
    ></icc-list>
